'use strict';

/**
 * Component for the text
 *
 * @category   View
 * @module     collection.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var LayoutView = require('base/Colido.LayoutView');

var template = require('../../templates/components/field-text.hbs');

var TextComponent = LayoutView.extend({
    template: template,

    className: function() {
        var field = this.getOption('field');

        return 'form-component component-' + _.camelToHyphen(field.type);
    },

    ui: {
        'autosizeTextarea': 'textarea[data-autosize="true"]',
    },

    events: {
        'input @ui.autosizeTextarea': 'fixTextareaSize',
    },

    viewData: {
        field: function() {
            return this.getOption('field');
        },

        isGroupChild: function() {
            return this.getOption('isGroupChild');
        },
    },

    /**
     * Resets the states and data of the component
     */
    reset: function() {},

    onAttach: function() {
        this.fixTextareaSize(this.ui.autosizeTextarea);
    },

    onResize: function() {
        this.fixTextareaSize(this.ui.autosizeTextarea);
    },

    getData: function() {
        var data = {};
        var field = this.getOption('field');

        data[field.name] = this.$('[name="' + field.name + '"]').val().trim();

        return data;
    },
});

module.exports = TextComponent;